import React from 'react';
import { Card, List } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { arrayToMap, useQueryCreator } from '~/hooks/useQueryCreator';
import { securityService } from '~/services';
import { useQuery } from '@tanstack/react-query';

export interface FeatureNotEnabledProps {
  requestedOptIn: string[];
  disabledFeature?: boolean;
}

export const FeatureNotEnabled = ({ requestedOptIn, disabledFeature }: FeatureNotEnabledProps) => {
  const optInMap = useQuery({
    ...useQueryCreator(securityService.optIns.search, {
      args: [],
    }),
    select: (data) => arrayToMap(data, 'optInId'),
  });

  const message = disabledFeature
    ? requestedOptIn.length > 1
      ? 'You must have one of the following features disabled to view this page'
      : 'You must have the following feature disabled to view this page'
    : requestedOptIn.length > 1
      ? 'You must have one of the following features enabled to view this page'
      : 'You must have the following feature enabled to view this page';
  const featureList = (
    <List
      size={'small'}
      footer={
        <p>
          Please contact <strong>help@shipium.com</strong> for details about enabling this feature.
        </p>
      }
    >
      {requestedOptIn.map((optIn) => (
        <List.Item>
          <List.Item.Meta
            avatar={<ExclamationCircleOutlined />}
            title={optInMap.data?.[optIn]?.name || optIn}
            description={optInMap.data?.[optIn]?.description}
          />
        </List.Item>
      ))}
    </List>
  );
  return <Card title={message}>{featureList}</Card>;
};

export default FeatureNotEnabled;
